import {
	ChangeDetectionStrategy,
	Component,
	Input
} from '@angular/core';

import { VgStates } from './videogular/VgStates';
import { VideogularComponent } from './videogular/Videogular.Component';

import { PlaybackOption } from './PlaybackOption';
import { VbStartAtManagerComponent } from './VbStartAtManager.Component';

@Component({
	selector: 'vb-overlay-buffering-manager',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: ``,
	standalone: false
})
export class VbOverlayBufferingManagerComponent {
	@Input() public vbStartAtManager: VbStartAtManagerComponent;

	constructor(
		private vgApi: VideogularComponent
	) {}

	public get isBuffering(): boolean {
		const activeSource: PlaybackOption = this.vgApi.activeSource;
		const isActiveSourceAvailable: boolean = activeSource && !activeSource.isUnavailable;
		const isStartAtSeeking: boolean = this.vbStartAtManager.isStartAtSeeking;
		const isPausedVOD: boolean = activeSource && !activeSource.isLive && this.vgApi.currentState !== VgStates.PLAY && !isStartAtSeeking;
		const isStopped: boolean = activeSource && activeSource.isLive && this.vgApi.currentState === VgStates.STOP;

		return this.vgApi.isSupportedPlaybackOptions &&
			isActiveSourceAvailable &&
			!isStopped &&
			!isPausedVOD &&
			(
				!this.vgApi.isReady ||
				this.vgApi.isBuffering ||
				isStartAtSeeking
			);
	}
}
